import { render } from "./MenuBarDashboard.vue?vue&type=template&id=08aad88b&scoped=true"
import script from "./MenuBarDashboard.vue?vue&type=script&lang=js"
export * from "./MenuBarDashboard.vue?vue&type=script&lang=js"

import "./MenuBarDashboard.vue?vue&type=style&index=0&id=08aad88b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08aad88b"]])

export default __exports__